import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getSquareLogoData } from '../HeadlinesSection/helpers'
import { isAllImageAssetsReady } from '../../helpers'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { getInitialValues } from './fields'
import { SQUARE_LOGO, squareLogoHeight, squareLogoWidth } from '../../../../fields'
import { squareLogoValidationSchema } from '../../../../validations'
import { validationSchema } from './validation'

const SquareLogoSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalSquareLogoAssets = useMemo(() => getSquareLogoData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalSquareLogoAssets), [originalSquareLogoAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalSquareLogoAssets,
    fieldType: googleAssetFieldType.LOGO,
    sectionValueKey: SQUARE_LOGO,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    validationSchema,
    title,
    adAccount
  })

  const { values } = purifiedFormik

  const isImagesReady = isAllImageAssetsReady(values, SQUARE_LOGO)

  const isEmptyList = !values[SQUARE_LOGO].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      submitBtnDisabled={!isImagesReady}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={SQUARE_LOGO}
        validationSchema={squareLogoValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add square image' : 'Add another square image'}
        width={squareLogoWidth}
        height={squareLogoHeight}
      />
    </EditForm>
  )
}

export default SquareLogoSectionForm
